import { Table } from "north.js";
import React, { useState } from "react";
import styled from "styled-components";

import { PageBar, Spinner } from "src/shared/components";

import { TMentorShiftSchedule } from "../types";

interface ListViewScheduleProps {
  fetchingShifts: boolean;
  adminShifts: TMentorShiftSchedule[];
  setSelectedShift: (shiftId: number) => void;
  setViewModal: (visible: boolean) => void;
}

const AdminShiftListView: React.FC<ListViewScheduleProps> = ({
  fetchingShifts,
  adminShifts,
  setSelectedShift,
  setViewModal,
}) => {
  const [page, setPage] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);

  const handleShiftClick = (shift: any) => {
    setSelectedShift(shift.shift_id);
    setViewModal(true);
  };

  const tableData = adminShifts.map((shift: TMentorShiftSchedule) => {
    return {
      shift: shift?.shift,
      date: shift?.date,
      time_start: (
        <div style={{ textAlign: "right" }}>
          {shift?.time_start
            .toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
              timeZone: "America/New_York",
            })
            .replace(":00", "")}
        </div>
      ),
      time_end: (
        <div style={{ textAlign: "right" }}>
          {shift?.time_end
            .toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
              timeZone: "America/New_York",
            })
            .replace(":00", "")}
        </div>
      ),
      spots_left: (
        <div style={{ textAlign: "center" }}>{shift?.spots_left}</div>
      ),
      view: (
        <ViewButton
          onClick={() => {
            handleShiftClick(shift);
          }}
        >
          View
        </ViewButton>
      ),
    };
  });

  const leftAlignment: "left" | "center" | "right" = "left";
  const centerAlignment: "left" | "center" | "right" = "center";
  const rightAlignment: "left" | "center" | "right" = "right";

  const tableColumns = [
    {
      id: "shift",
      name: "SHIFT",
      align: leftAlignment,
    },
    {
      id: "date",
      name: "DATE",
      align: leftAlignment,
    },
    {
      id: "time_start",
      name: "TIME START",
      align: rightAlignment,
    },
    {
      id: "time_end",
      name: "TIME END",
      align: rightAlignment,
    },
    {
      id: "spots_left",
      name: "SPOTS LEFT",
      align: centerAlignment,
    },
    {
      id: "view",
      name: "View",
      hideLabel: true,
      align: leftAlignment,
    },
  ];

  return (
    <>
      {fetchingShifts ? (
        <Spinner text="Loading shifts..." />
      ) : (
        <>
          <Table
            columns={tableColumns}
            data={tableData}
            horizontalPadding={16}
            verticalPadding={10}
            showFooter
            page={page}
            itemsPerPage={itemsPerPage}
          />
          <PageBar
            page={page}
            itemsPerPage={itemsPerPage}
            totalItems={tableData.length}
            onPageChange={setPage}
            onItemsPerPageChange={setItemsPerPage}
          />
        </>
      )}
    </>
  );
};

const ViewButton = styled.div`
  border-radius: 4px;
  border: 1px solid #d1d5db;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  color: #1f2937;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  padding: 2px 8px;

  &:hover {
    cursor: pointer;
  }
`;

export default AdminShiftListView;
